<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" destroy-on-close title="设置密码" width="600px">
		<div>
			<el-form @submit.native.prevent ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<!-- <el-col :span="24" v-if="isHasPwd">
						<el-form-item label="原密码：" prop="oldPassword">
							<el-input :type="showOldPassword ? 'text' : 'password'" v-model.trim="form.oldPassword" placeholder="请输入原密码">
								<i slot="suffix" class="iconfont" :class="showOldPassword ? 'icon-eye' : 'icon-eye-close'" @click="showOldPassword = !showOldPassword" style="cursor: pointer; margin-top: 10px"></i>
							</el-input>
						</el-form-item>
					</el-col> -->
					<el-col :span="24">
						<el-form-item label="新密码：" prop="password">
							<el-input :type="showPassword ? 'text' : 'password'" v-model.trim="form.password" placeholder="请输入新密码">
								<i slot="suffix" class="iconfont" :class="showPassword ? 'icon-eye' : 'icon-eye-close'" @click="showPassword = !showPassword" style="cursor: pointer; margin-top: 10px"></i>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="确认密码：" prop="rePassword">
							<el-input :type="showRePassword ? 'text' : 'password'" v-model.trim="form.rePassword" placeholder="请输入确认密码">
								<i slot="suffix" class="iconfont" :class="showRePassword ? 'icon-eye' : 'icon-eye-close'" @click="showRePassword = !showRePassword" style="cursor: pointer; margin-top: 10px"></i>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 确定 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import EFormat from '@/utils/EFormat';
import TMessage from '@/utils/TMessage';
import { mapGetters } from 'vuex';
import { postMemberUpdatePhonePwd } from '@/api/user/user.js';

export default {
	name: 'DialogEditPwd',
	props: {
		isHasPwd: {
			type: Boolean,
			default: false
		}
	},
	data() {
		//校验密码
		const validatePass = (rule, value, callback) => {
			let reg = /([A-Za-z]|[0-9]){4,16}/;
			if (value === '') {
				callback(new Error('密码不可为空'));
			} else if (reg.test(value) === false) {
				callback(new Error('新密码必须由 4-16位字母、数字组成'));
			} else {
				callback();
			}
		};
		//校验重复密码
		const validatePassCheck = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('确认密码不可为空'));
			} else if (value !== this.form.password) {
				callback(new Error('两次密码不一致'));
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			form: {
				oldPassword: '',
				password: '',
				rePassword: ''
			},
			rules: {
				oldPassword: {
					required: true,
					trigger: 'blur',
					message: '原密码不可为空'
				},
				password: [
					{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}
				],
				rePassword: [
					{
						required: true,
						validator: validatePassCheck,
						trigger: 'blur'
					}
				]
			},
			showPassword: false,
			showRePassword: false,
			showOldPassword: false
		};
	},
	computed: {
		...mapGetters('User', ['uinfo'])
	},
	watch: {
		dialogVisible(val) {
			if (!val) {
				this.resetForm();
			}
		}
	},
	methods: {
		handleClose() {
			this.resetForm();
			this.$emit('cancel');
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					this.updatePassword();
				}
			});
		},

		//更新密码
		updatePassword() {
			// let { oldPassword, password } = this.form;
			// if(this.isHasPwd){
			// 	postMemberUpdatePhonePwd({ oldPwd: oldPassword, newPwd: password }).then(res => {
			// 		let { code, data, msg } = res;
			// 		if (code == 200) {
			// 			// TMessage.success('密码设置成功');
			// 			this.$emit('confirmInfo');
			// 		} else if (msg) {
			// 			TMessage.warning(msg);
			// 		}
			// 	});
			// }else{
			// 	postMemberUpdatePhonePwd({ newPwd: this.form.password }).then(res => {
			// 		let { code, data, msg } = res;
			// 		if (code == 200) {
			// 			// TMessage.success('密码设置成功');
			// 			this.$emit('confirmInfo');
			// 		} else if (msg) {
			// 			TMessage.warning(msg);
			// 		} else {
			// 			TMessage.warning('密码设置失败');
			// 		}
			// 	});
			// }
			postMemberUpdatePhonePwd({ newPwd: EFormat.base64encode(this.form.password) }).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					// TMessage.success('密码设置成功');
					this.$emit('confirmInfo');
				} else if (msg) {
					TMessage.warning(msg);
				} else {
					TMessage.warning('密码设置失败');
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
